import type { ContentData } from '@/lib/serverDataFetchers'

interface AboutProps {
  content?: ContentData
}

const About = ({ content }: AboutProps) => {
  return (
    <div className="relative isolate overflow-hidden bg-white px-6 py-24 sm:py-32 lg:overflow-visible lg:px-0">
      <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 lg:mx-0 lg:max-w-none lg:grid-cols-2 lg:items-start lg:gap-y-10">
        <div className="lg:col-span-2 lg:col-start-1 lg:row-start-1 lg:mx-auto lg:grid lg:w-full lg:max-w-7xl lg:grid-cols-2 lg:gap-x-8 lg:px-8">
          <div className="lg:pr-4">
            <div className="lg:max-w-lg">
              <p className="text-2xl font-bold leading-7 text-[rgb(55,134,181)]">About Us</p>
              <h1 className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
                {content?.about_title || "About Us"}
              </h1>
            </div>
          </div>
        </div>

        <div className="-ml-12 -mt-12 p-12 lg:sticky lg:top-4 lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:overflow-hidden hidden lg:block">
          <img
            alt="Experience Capture by KES Global Advisors"
            src="https://kesimages.sfo3.cdn.digitaloceanspaces.com/KES/kes_about_us.webp"
            width={760}
            height={570}
            className="w-[48rem] max-w-none rounded-xl bg-gray-900 shadow-xl ring-1 ring-gray-400/10 sm:w-[57rem]"
            loading="lazy"
          />
        </div>

        <div className="mt-[-35px] lg:mt-[-15px] lg:col-span-2 lg:col-start-1 lg:row-start-2 lg:mx-auto lg:grid lg:w-full lg:max-w-7xl lg:grid-cols-2 lg:gap-x-8 lg:px-8">
          <div className="lg:pr-4">
            <div className="max-w-xl text-base leading-7 text-gray-700 lg:max-w-lg">
              <p>{content?.about_description || "Delivering exceptional advisory services to help our clients achieve their strategic objectives."}</p>

              <p>
                <br /> We approach every engagement as a partnership, with the end goal being to create and recognize significant and sustainable value.
              </p>

              <h2 className="mt-16 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">Our Mission</h2>
              <p className="mt-6">{content?.mission_text || "To provide strategic advisory services that create sustainable value for our clients."}</p>

              <h2 className="mt-16 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">Our Commitment</h2>
              <p className="mt-6">{content?.commitment_text || "Committed to building lasting relationships with our clients through trust, integrity, and excellence."}</p>
              <p className="mt-6">
                We believe that focusing on our clients and their needs creates a business based on relationships sustained over decades.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default About
